var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8C14 11.3144 11.3135 14 8 14C4.68652 14 2 11.3144 2 8C2 4.68749 4.68652 2 8 2C11.3135 2 14 4.68749 14 8ZM8 9.20968C7.38536 9.20968 6.8871 9.70794 6.8871 10.3226C6.8871 10.9372 7.38536 11.4355 8 11.4355C8.61464 11.4355 9.1129 10.9372 9.1129 10.3226C9.1129 9.70794 8.61464 9.20968 8 9.20968ZM6.9434 5.20937L7.12286 8.49969C7.13126 8.65366 7.25856 8.77419 7.41275 8.77419H8.58725C8.74144 8.77419 8.86874 8.65366 8.87714 8.49969L9.05661 5.20937C9.06568 5.04306 8.93327 4.90323 8.76672 4.90323H7.23326C7.06671 4.90323 6.93432 5.04306 6.9434 5.20937Z",
    fill: "#E32707"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.2eb570e230db9dabcaab3a0cd0801ae5.svg";
export { ForwardRef as ReactComponent };